import { HudActions } from "../../../../components/ui/hud/HUDUI";
import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../misc/constants";
import { DaarcBaseScenario } from "../../../DaarcBaseScenario";
import GeneralNeutralStateMain, { GeneralNeutralStateMainConfig, GeneralNeutralStatePart1Config } from "../GeneralNeutralStateMain";

export default class GeneralNeutralStatePart1 extends BaseScenarioPart<DaarcBaseScenario> {
	public static disableMenuItemCallback: () => void = null;
	public static disableMenuItemCallbackPreOxygenate: () => void = null;
	public static calledForOORam = false;
	private get config(): GeneralNeutralStatePart1Config {
		return this.scenarioConfig.part1Config;
	}
	
	constructor(private main: GeneralNeutralStateMain, private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralNeutralStateMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;

		this.main.loopVideo(this, this.config.hudIdleVideoChapter());

		
		context._scenario.currentTaskMessage = constants.isLite && this.config.isCric && !GeneralNeutralStatePart1.calledForOORam ? 'Please call for OORAM Level 3 provider / EMS' : 'Please call for Vortex';
		
		context._scenario.hudId = context._scenario.uiWrapper.displayHUD({
			score: this._scenario.totalScore,
			maxScore: this._scenario.maxScore,
			disabledNPCs: this.scenarioConfig.disabledNPCs,
			disabledActions: this.scenarioConfig.disabledActions,
			onActionClicked: (actionType: HudActions) => {
				if(context.main.onHudActionClicked(actionType)) {
					return true;
				}

				if(constants.isLite && this.config.isCric && !GeneralNeutralStatePart1.calledForOORam) {
					switch(actionType) {
						case HudActions.CallForOORAM:
							if(context.config.onCalledForOORam) {
								context.config.onCalledForOORam();
							}
							GeneralNeutralStatePart1.calledForOORam=true;

							var onDoneWithPopup = context._scenario.doSomething('Calling for OORAM Level 3 provider / EMS');
			
							setTimeout(() => {
								onDoneWithPopup();
								var txt = 'OORAM has been called';
								context._scenario.uiWrapper.displayNotificationUI({
									text: `<p class='notification-text'>${txt}</p>`,
									onDismissed: () => {
									}
								})
								context.start();
							}, constants.doSomethingTimeout);

							return true;
						default:
							if(context.config.onOORamCalledForAnythingElse) {
								context.config.onOORamCalledForAnythingElse();
							}
							context._scenario.displayMessage(context._scenario.currentTaskMessage);
							return false;
					}
				} else {
					switch(actionType) {
						case HudActions.CallForVortex:
							if(context.config.onCalledForVortex) {
								context.config.onCalledForVortex();
							}
							context._scenario.vortexCalled=true;
							context._scenario.addScore(context._scenario.vortexPoints);
							context.onDone();
							return true;
						default:
							context._scenario.vortexPoints = 500;
							if(context.config.onCalledForAnythingElse) {
								context.config.onCalledForAnythingElse();
							}
							context._scenario.displayMessage(context._scenario.currentTaskMessage);
							return false;
					}
				}
			},
			actionsDisableCallbacks: [
				{
					action: HudActions.AdministerMedications,
					callback: (onShouldDisable: () => void) => {
						GeneralNeutralStatePart1.disableMenuItemCallback = onShouldDisable;
					}
				},
				{
					action: HudActions.PreOxygenatePatient,
					callback: (onShouldDisable: () => void) => {
						GeneralNeutralStatePart1.disableMenuItemCallbackPreOxygenate = onShouldDisable;
					}
				}
			]
		});
		
		context._scenario.uiWrapper.displaySideMenu({
			updatedStuff: {
				isApneaTimerIdle: true
			}
		}, context._scenario.sideMenuId);

		context.scenario.toolbagId = context._scenario.toolbagId = context._scenario.uiWrapper.displayToolbag({
			isTestScenario: context.scenarioConfig.isTestScenario,
			onShouldShowOverlay: () => {
				context._scenario.displayMessage(context._scenario.currentTaskMessage);
				return false;
			}
		}, context.scenario.toolbagId);
	}
}